<div class="reduce-risk-container text-center">
	<div class="reduce-risk-bottom">
		<h2 class="mb-5 reduce-risk-header">The RegScale Difference</h2>
		<p class="reduce-risk-content">
			RegScale can support a single user on a laptop up to a large
			installation with <br class="d-none d-sm-block" />
			thousands of concurrent users with a universal deployment model
			(on premises,<br class="d-none d-sm-block" />
			cloud, or even classified/air-gapped networks). <br />
			<br />
			We provide a free version (Community Edition), custom hosted version
			<br class="d-none d-sm-block" />
			(Managed Edition), and an Enterprise Edition (EE) offering a range
			of features <br class="d-none d-sm-block" />
			and pricing based on your budget and needs.
		</p>
	</div>
</div>
